<template>
  <div class="mt-component-form">
    <vs-row class="my-4">
      <h5 style="align-self: center"><i class="dot"></i>{{ title }}</h5>
      <div class="ml-auto flex">
        <!--부서 선택 팝업 표시-->
        <div>
          <field-selector v-if="!isPrint" :value="multipleFields" rows="1" only-button multiple :readonly="isReadonly" select-all-active @select="handleMultipleFieldSelect" />
        </div>
        <vs-button v-if="!isPrint && !isReadonly" class="ml-2" color="secondary" @click="handleAddRow">항목추가</vs-button>
        <vs-button v-if="!isPrint && !isReadonly" class="ml-2" color="secondary" type="border" @click="handleRemoveRow">선택삭제</vs-button>
      </div>
    </vs-row>

    <div class="grid row-header" style="grid-template-columns: auto 1fr 1fr 1fr 1fr 120px 100px">
      <div>
        <div v-if="!isPrint && !isReadonly" style="width: 80px" class="row-header__item">
          <vs-checkbox v-model="equipAllCheck" @change="changeAllCheck"></vs-checkbox>
        </div>
      </div>
      <div class="row-header__item">{{ column1Label }}</div>
      <div class="row-header__item">담당자</div>
      <div class="row-header__item">연락처</div>
      <div class="row-header__item">비고</div>
      <div class="row-header__item">점검 상태</div>
      <div class="row-header__item cursor-pointer" @click="openAll">
        <span class="mr-2">점검 내용</span>
        <span v-if="isOpenAll">▲</span>
        <span v-else>▼</span>
      </div>
    </div>
    <!-- rows -->
    <div v-for="(rows, indexRows) in pobList" :key="indexRows">
      <div class="grid row-content" style="grid-template-columns: auto 1fr 1fr 1fr 1fr 120px 100px" :key="indexRows">
        <div>
          <div v-if="!isPrint && !isReadonly" style="width: 80px" class="none-border-center">
            <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
          </div>
        </div>
        <div class="item-area">
          <field-selector v-if="!isPrint" rows="1" v-model="rows.data1" class="w-full flex-1 p-1" :readonly="isReadonly" @select="handleFieldSelect(rows, $event)" />
          <span v-else class="print-input">{{ rows.data1 }}</span>
        </div>
        <div class="item-area">
          <ml-input v-if="!isPrint" rows="1" v-model="rows.data2" class="w-full flex-1 p-1" :readonly="isReadonly" />
          <span v-else class="print-input">{{ rows.data2 }}</span>
        </div>
        <div class="item-area">
          <ml-input v-if="!isPrint" rows="1" v-model="rows.data3" class="w-full flex-1 p-1" :readonly="isReadonly" />
          <span v-else class="print-input">{{ rows.data3 }}</span>
        </div>
        <div class="item-area">
          <ml-input v-if="!isPrint" rows="1" v-model="rows.data4" class="w-full flex-1 p-1" :readonly="isReadonly" />
          <span v-else class="print-input">{{ rows.data4 }}</span>
        </div>
        <!--getScore-->
        <div class="item-area flex items-center justify-center">
          <span v-if="getScore(rows.inspectList, rows.etcList) === '양호'" style="color: #28c76f">양호</span>
          <span v-else-if="getScore(rows.inspectList, rows.etcList) === '미흡'" style="color: #ea5455">미흡</span>
          <span v-else>해당없음</span>
        </div>
        <div class="item-area cursor-pointer flex items-center justify-center" @click="rows.open = !rows.open">
          <span v-if="rows.open" title="점검 내용 접기">▲</span>
          <span v-else title="점검 내용 펼치기">▼</span>
        </div>
      </div>
      <table-inspect
        v-if="rows.open"
        class="pl-4 pb-4"
        title="반기별 점검"
        :is-print="isPrint"
        :is-readonly="isReadonly"
        :is-show-title="true"
        :list="rows.inspectList"
        :is-note="'note' in rows.inspectList[0]"
        :table-header-title="inspectHeaderTitle || '자가진단 항목'"
        :table-header-yes="inspectHeaderYes || '양호'"
        :table-header-no="inspectHeaderNo || '미흡'"
        :table-header-na="inspectHeaderNa || '해당없음'"
        :table-header-note="inspectHeaderNote || '비고(보완계획)'"
        show-score
        :score="getScore(rows.inspectList, rows.etcList)"
        @update-list-check="
          (indexRows, text) => {
            updateListCheck(rows, indexRows, text);
          }
        "
      />

      <table-custom v-if="rows.open && useEtc" v-model="rows.etcList" title="기타 점검" :board="{ readonly: isReadonly }" :table-data="etcTable" class="border-bottom" thema="label" @input="updateList" />
    </div>
  </div>
</template>

<script>
import FieldSelector from "@/components/selector/FieldSelector";
import TableInspect from "@/components/TableInspect";
import PopupSearchFieldByType from "@/popup/PopupSearchFieldByType.vue";
import TableCustom from "@/components/TableCustom.vue";
export default {
  name: "TablePlaceOfBusiness",
  components: { TableCustom, PopupSearchFieldByType, FieldSelector, TableInspect },
  props: {
    list: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
    title: {
      type: String,
      default: "점검 대상 부서",
    },
    column1Label: {
      type: String,
      default: "부서명",
    },
    propsInspectTable: Array,
    useEtc: {
      type: Boolean,
      default: true,
    },
    inspectHeaderTitle: String,
    inspectHeaderYes: String,
    inspectHeaderNo: String,
    inspectHeaderNa: String,
    inspectHeaderNote: String,
  },
  emits: ["updateList"],
  data() {
    return {
      equipAllCheck: false,
      pobList: [],
    };
  },
  computed: {
    isOpenAll() {
      let now = false;
      for (const data of this.pobList) {
        if (data.open) {
          now = true;
          break;
        }
      }
      return now;
    },
    // get, set
    multipleFields() {
      const fields = [];
      for (const item of this.pobList) {
        if (!item.data1) {
          continue;
        }
        fields.push({
          id: item.data1,
          field_name: item.fieldName,
        });
      }
      return fields;
    },
    inspectTable() {
      if (this.propsInspectTable) return this.propsInspectTable;
      return [
        {
          id: 1,
          label: "목표와 경영방침에 따른 설정",
          is_checked: "",
        },
        {
          id: 2,
          label: "유해·위험요인을 확인하여 개선하는 업무절차에 따른 유해·위험요인 발굴 및 개선",
          is_checked: "",
        },
        {
          id: 3,
          label: "안전보건관계자 등의 충실한 업무 수행",
          is_checked: "",
        },
        {
          id: 4,
          label: "종사자 의견 수렴 절차에 따라 개선방안 마련 및 이행",
          is_checked: "",
        },
        {
          id: 5,
          label: "중대산업재해가 발생하거나, 발생할 급박한 위험이 있을 경우를 대비한 매뉴얼에 따른 조치",
          is_checked: "",
        },
        {
          id: 6,
          label: "도급·용역·위탁 시 수급인의 산업재해 예방 조치 능력에 관한 평가 기준, 안전보건을 위한 적정 관리비용 기준, 적정 기간 기준에 따른 도급·용역·위탁 관리",
          is_checked: "",
        },
        {
          id: 7,
          label: "안전보건관계법령에 따른 의무 이행",
          is_checked: "",
        },
        {
          id: 8,
          label: "유해·위험한 작업에 관한 안전·보건에 관한 교육 실시",
          is_checked: "",
        },
      ];
    },
    etcTable() {
      return [
        { id: "content", title: "점검내용", type: "text", placeholder: "점검내용" },
        {
          id: "is_checked",
          type: "checks",
          selectData: ["양호", "미흡", "해당없음"],
          width: "130",
        },
      ];
    },
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value && value.length > 0) {
          this.pobList = value;
        }
      },
    },
  },
  methods: {
    checkForm(value, indexRows, text) {
      if (value.target.checked) {
        this.$emit("update-list-check", indexRows - 1, text);
      } else {
        this.$emit("update-list-check", indexRows - 1, "");
      }
    },
    // 항목추가
    handleAddRow() {
      this.pobList.push({
        is_checked: this.equipAllCheck,
        open: false,
        fieldName: "",
        data1: "",
        data2: "",
        data3: "",
        data4: "",
        inspectList: JSON.parse(JSON.stringify(this.inspectTable)),
        etcList: [],
      });
      this.updateList();
    },
    // 선택삭제
    handleRemoveRow() {
      for (let i = 0; i < this.pobList.length; i++) {
        if (this.pobList[i].is_checked) {
          this.pobList.remove(this.pobList[i]);
          i = -1;
        }
      }

      this.equipAllCheck = false;
      this.updateList();
    },
    /**
     * 목록에서 필드를 하나 선택한 경우에 실행됨
     * @param rows 리스트 아이템
     * @param selectedField 선택된 필드
     */
    handleFieldSelect(rows, selectedField) {
      rows.fieldName = selectedField.field_name;
      rows.data1 = selectedField.id;
      rows.data2 = selectedField.manager_name;
      rows.data3 = selectedField.phone;
    },
    handleMultipleFieldSelect(selectedFields) {
      // 만약에 popList 중에서, selectedFields 에 없는 항목들은 삭제한다.
      for (let i = 0; i < this.pobList.length; i++) {
        const foundIndex = selectedFields.findIndex((item) => item.id === this.pobList[i].data1);
        if (foundIndex === -1) {
          this.pobList.remove(this.pobList[i]);
          i = -1;
        }
      }

      // this.pobList 아이템 중에서, 없는 항목들은 추가한다
      for (const selectedField of selectedFields) {
        const foundIndex = this.pobList.findIndex((item) => item.data1 === selectedField.id);
        if (foundIndex === -1) {
          this.pobList.push({
            is_checked: this.equipAllCheck,
            open: false,
            fieldName: selectedField.field_name,
            data1: selectedField.id,
            data2: selectedField.manager_name,
            data3: selectedField.phone,
            data4: "",
            inspectList: JSON.parse(JSON.stringify(this.inspectTable)),
            etcList: [],
          });
        }
      }

      this.updateList();
    },
    // 일괄 체크
    changeAllCheck() {
      for (const data of this.pobList) {
        data.is_checked = this.equipAllCheck;
      }
    },
    // update
    updateList() {
      this.$emit("updateList", this.pobList);
    },
    updateListCheck(obj, indexRows, text) {
      obj.inspectList[indexRows].is_checked = text;
    },
    openAll() {
      const isOpenAll = !this.isOpenAll;
      for (const data of this.pobList) {
        data.open = isOpenAll;
      }
    },
    /**
     * 모든 항목 양호 : 양호
     * 양호 + 해당없음 혼합 : 양호
     * 전체 해당없음 : 양호
     * 1개 이상 미흡 : 미흡
     * @param inspectList
     * @param etcList
     */
    getScore(inspectList, etcList) {
      let score = "양호";

      if (inspectList && inspectList.length > 0) {
        for (const data of inspectList) {
          if (`${data.is_checked}`.toLowerCase() === "no") {
            score = "미흡";
            break;
          }
        }
      }

      if (this.useEtc && score === "양호") {
        if (etcList && etcList.length > 0) {
          for (const data of etcList) {
            if (`${data.is_checked}` === "미흡") {
              score = "미흡";
              break;
            }
          }
        }
      }

      return score;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  border-bottom: $border;
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
